import { render, staticRenderFns } from "./StockviewPricePosition.vue?vue&type=template&id=44a33a8d&"
import script from "./StockviewPricePosition.vue?vue&type=script&lang=js&"
export * from "./StockviewPricePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports